import React, {useEffect, useState} from 'react';
import {Drawer, List, Toolbar} from "@material-ui/core";
import MenuIconButton from "../../components/MenuIconButton/MenuIconButton.jsx";
import {makeStyles} from "@material-ui/styles";
import {checkCondition} from "../../utils/groups.js";
import {useSelector} from "react-redux";
import {getProfile} from "../../redux/reducers/user-profile-reducer.js";
import {sideBarButtons} from "./sideBarButtons.js";

const sideBarMenuConfigs = [
    {
        buttons: [
            sideBarButtons.act,
            sideBarButtons.library,
            sideBarButtons.users,
            sideBarButtons.devices,
            sideBarButtons.projects,
            sideBarButtons.normativeDocuments,
            sideBarButtons.charts,
            sideBarButtons.podr,
            sideBarButtons.dataLens,
            sideBarButtons.tests,
        ],
        conditions: {isStaff: true}
    },
    {
        buttons: [
            sideBarButtons.act,
            sideBarButtons.library,
            sideBarButtons.charts,
            sideBarButtons.dataLens,
        ],
        conditions: {isStaff: false, role: 'project_manager'}
    },
    {
        buttons: [
            sideBarButtons.act,
            sideBarButtons.library,
            sideBarButtons.charts,
            sideBarButtons.podr,
            sideBarButtons.dataLens,
        ],
        conditions: {isStaff: false, role: 'employer'}
    },
    {
        buttons: [
            sideBarButtons.act,
            sideBarButtons.library,
            sideBarButtons.tests,
        ],
        conditions: {isStaff: false, role: 'supervisor'}
    },
    {
        buttons: [
            sideBarButtons.act,
            sideBarButtons.library,
        ],
        conditions: {isStaff: false, role: 'moderator'}
    },
    {
        buttons: [
            sideBarButtons.act,
        ],
        conditions: {isStaff: false, role: 'contractor'}
    },
    {
        buttons: [
            sideBarButtons.library,
            sideBarButtons.normativeDocuments,
            sideBarButtons.projects,
            sideBarButtons.dataLens,
        ],
        conditions: {isStaff: false, role: 'safety_engineer'}
    },
    {
        buttons: [
            sideBarButtons.act,
            sideBarButtons.library,
            sideBarButtons.charts,
            sideBarButtons.podr,
            sideBarButtons.dataLens,
        ],
        conditions: {isStaff: false, role: 'project_editor'}
        
    },
    {
        buttons: [
            sideBarButtons.act,
            sideBarButtons.library,
            sideBarButtons.charts,
            sideBarButtons.podr,
            sideBarButtons.dataLens,
        ],
        conditions: {isStaff: false, role: 'employer_additional'}
    },
    {
        buttons: [
            sideBarButtons.act,
        ],
        conditions: {isStaff: false, role: 'field_contractor'}
    },
]

const useStyles = makeStyles((theme) => ({
    drawer: {
        width: theme.spacing(7) + 1,
        flexShrink: 0
    },
    drawerPaper: {
        width: theme.spacing(7) + 1,
        overflowX: "hidden",
    }
}))

const SideBar = () => {
    const classes = useStyles()

    const [sideBarButtons, setSideBarButtons] = useState([])

    const {user} = useSelector(getProfile)

    useEffect(() => {
        setSideBarButtons(sideBarMenuConfigs.find(config => checkCondition(config.conditions, user))?.buttons)
    }, [user])

    return (
        <Drawer
            variant={'permanent'}
            className={classes.drawer}
            classes={{
                paper: classes.drawerPaper
            }}
        >
            <Toolbar/>
            <List>
                {sideBarButtons?.map(el =>
                    <MenuIconButton
                        key={`sideBar-menu-item-to-${el.route}`}
                        label={el.label}
                        icon={el.icon}
                        route={el.route}
                    />)}
            </List>
        </Drawer>
    );
};

export default SideBar;